import type {
  CreateVehicleExtraDto,
  FindAllVehicleExtrasQueryDto,
  UpdateVehicleExtraDto,
} from '@/entities/vehicle-extra.entity';
import { Service } from './http-service';
import type { EditAutoAssignVehicleExtraDto, VehicleExtra } from '@carvia/ros-client-types';

class VehicleExtrasService extends Service<
  VehicleExtra,
  CreateVehicleExtraDto,
  UpdateVehicleExtraDto
> {
  constructor() {
    super('/vehicle-extras');
  }

  async getAllWithQuery(params: FindAllVehicleExtrasQueryDto) {
    const res = await this.httpClient.get<VehicleExtra[]>(`${this.endpoint}`, {
      params,
    });
    return res.data;
  }

  async editAutoAssignVehicleExtra(dto: EditAutoAssignVehicleExtraDto) {
    const res = await this.httpClient.post<VehicleExtra>(
      `${this.endpoint}/edit-auto-assign-extra`,
      dto,
    );
    return res.data;
  }
}

export const vehicleExtrasService = new VehicleExtrasService();
